import { Spin } from 'antd';

export const FullpageSpinner = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <Spin size="large" spinning />
    </div>
  );
};
